goog.provide("shadow.js.shim.module$$mui$material$MenuItem$default");
shadow.js.shim.module$$mui$material$MenuItem$default = shadow.js.require(504, {})["default"];
